import { EInvestorDegreeType, EUserRole, EUserType } from 'src/app/shared/shared-data-models';

export interface UserDto {
  id?: string | undefined;
  fullName?: string | undefined;
  lastName?: string | undefined;
  email?: string | undefined;
  nationalId?: string | undefined;
  phoneNumber?: string | undefined;
  birthDate?: string | undefined;
  fullAddress?: string | undefined;
  arabicName?: string | undefined;
  englishName?: string | undefined;
  investTypeId?: InvestorType;
  investorDegreeTypeId?: EInvestorDegreeType;
  isAcceptTerms?: boolean;
  userRoleId?: EUserRole;
  profileImageUrl?: string | undefined;
  isActivated?: boolean;
  isSuspended?: boolean;
  createdAt?: Date;
  createdBy?: string | undefined;
  updatedAt?: Date | undefined;
  updateBy?: string | undefined;
  deletedAt?: Date | undefined;
  deletedBy?: string | undefined;
  isDeleted?: boolean;
  gender?: Gender;
  isCompleteProfile?: boolean;
  serialNumber?: string | undefined;
  currentUsedInvestorAccountId?: string | undefined;
  moznStatus?: any;
  fileNumber?: string | undefined;
  investmentAccount?: string | undefined;
  anbVirtualIban?: string | undefined;
  withdrawIban?: string | undefined;
  crNumber?: string | undefined;
  parentId?: string | undefined;
  nationalityDescAr?: string;
  parentName?: string | undefined;
  beneficiaryRelationship?: string;
  realBeneficiaryName?: string;
  kycExpirationDate?: Date | undefined;
  kycRequestStatus?: KYCRequestStatus | undefined;
  kycRiskLevel?: string | undefined;
  overallRiskLevel?: string | undefined;
}

export enum KYCRequestStatus {
  Pending = 'Pending',
  Rejected = 'Rejected',
  Approved = 'Approved',
}

export enum KYCExpirationStatus {
  'Expiring Within 30 Days' = 'Expiring_Within_30_Days',
  Expired = 'Expired',
}

export enum InvestorDegreeType {
  Retail = 0,
  Qualified = 1,
}
export enum InvestorType {
  Individual = 'Individual',
  Company = 'Company',
}
export enum IdExpiryDateWithInMonth {
  One = 1,
  Two = 2,
  Three = 3,
}

export enum Gender {
  Male = 'Male',
  Female = 'Female',
  PreferredNotSay = 'PreferredNotSay',
}
export interface CreateUserDto {
  fullName?: string | undefined;
  lastName?: string | undefined;
  email?: string | undefined;
  nationalId?: string | undefined;
  phoneNumber?: string | undefined;
  birthDate?: string | undefined;
  arabicName?: string | undefined;
  englishName?: string | undefined;
  isAcceptTerms?: boolean;
  userTypeId?: EUserType;
  isActivated?: boolean;
  isSuspended?: boolean;
  gender?: Gender;
  password?: string | undefined;
  confirmPassword?: string | undefined;
}
export interface CreateAdminInputDto {
  englishName: string;
  email: string;
  birthDate: string;
  nationalId: string;
  phoneNumber: string;
  isActivated: boolean;
  password?: string | undefined;
  confirmPassword?: string | undefined;
}
export interface UpdateAdminInputDto {
  id: string;
  englishName: string;
  email: string;
  birthDate: string;
  nationalId: string;
  phoneNumber: string;
  isActivated: boolean;
}

export interface UserDtoGeneralResponse {
  success?: boolean;
  message?: string | undefined;
  status?: EResponseStatus;
  resource?: UserDto;
}
export enum EResponseStatus {
  Invalid = 'Invalid',
  Succeed = 'Succeed',
  Exception = 'Exception',
}
export interface BooleanGeneralResponse {
  success?: boolean;
  message?: string | undefined;
  status?: EResponseStatus;
  resource?: boolean;
}
export interface StringGeneralResponse {
  success?: boolean;
  message?: string | undefined;
  status?: EResponseStatus;
  resource?: string | undefined;
}

export interface UpdateDegreeInputDto {
  id: number;
  minimumRequirements: number;
}

export interface UpdateDegreeRequirementInputDto {
  id: string;
  titleEn: string | undefined;
  titleAr: string | undefined;
  descriptionEn: string | undefined;
  descriptionAr: string | undefined;
}

export interface InvestorDegreeDtoListGeneralResponse {
  success: boolean;
  message: string | undefined;
  status: EResponseStatus;
  resource: InvestorDegreeDto[] | undefined;
}

export interface InvestorDegreeRequirementDto {
  id: string;
  titleEn: string | undefined;
  titleAr: string | undefined;
  descriptionEn: string | undefined;
  descriptionAr: string | undefined;
}

export interface InvestorDegreeRequirementDtoListGeneralResponse {
  success: boolean;
  message: string | undefined;
  status: EResponseStatus;
  resource: InvestorDegreeRequirementDto[] | undefined;
}

export interface InvestorDegreeDto {
  id: number;
  titleEn: string | undefined;
  titleAr: string | undefined;
  descriptionEn: string | undefined;
  descriptionAr: string | undefined;
  minimumRequirements: number;
  investorDegreeRequirements: InvestorDegreeRequirementDto[] | undefined;
}

export interface CreateDegreeRequirementInputDto {
  degreeId: number;
  titleEn: string | undefined;
  titleAr: string | undefined;
  descriptionEn: string | undefined;
  descriptionAr: string | undefined;
}

export interface UserDtoPaginatedList {
  pageIndex: number;
  readonly totalPages: number;
  readonly totalCount: number;
  readonly hasPreviousPage: boolean;
  readonly hasNextPage: boolean;
  items: UserDto[] | null;
}
export interface UserSimpleProfileDto {
  id?: string | undefined;
  telephone?: string | undefined;
  fullName?: string | undefined;
}

export interface UserSimpleProfileDtoListGeneralResponse {
  success?: boolean;
  message?: string | undefined;
  status?: EResponseStatus;
  resource?: UserSimpleProfileDto[] | undefined;
}

export interface UpgradeDegreeRequestsDetailsDto {
  upgradeRequestId: string;
  documents: InvestorDegreeRequirementDocumentDto[] | undefined;
}

export interface InvestorDegreeRequirementDocumentDto {
  id: string;
  documentURL: string | undefined;
  requirementName: string | undefined;
}

export interface UpgradeDegreeRequestsDetailsDtoGeneralResponse {
  success: boolean;
  message: string | undefined;
  status: EResponseStatus;
  resource: UpgradeDegreeRequestsDetailsDto;
}

export interface UpgradeDegreeRequestsDto {
  id: string;
  investorName: string | undefined;
  investorId: string | undefined;
  iqamaNumber: string | undefined;
  phoneNumber: string | undefined;
  status: UpgradeProfileStatus;
}

export interface UpgradeDegreeRequestsDtoPaginatedList {
  pageIndex: number;
  totalPages: number;
  totalCount: number;
  readonly hasPreviousPage: boolean;
  readonly hasNextPage: boolean;
  items: UpgradeDegreeRequestsDto[] | undefined;
}

export interface UpgradeDegreeRequestsDtoPaginatedListGeneralResponse {
  success: boolean;
  message: string | undefined;
  status: EResponseStatus;
  resource: UpgradeDegreeRequestsDtoPaginatedList;
}

export enum UpgradeProfileStatus {
  Pending = 'Pending',
  Approved = 'Approved',
  Reject = 'Reject',
}
export interface UserPaginatedList {
  pageIndex?: number;
  totalPages?: number;
  totalCount?: number;
  readonly hasPreviousPage?: boolean;
  readonly hasNextPage?: boolean;
  items?: User[] | undefined;
}

export interface UserPaginatedListGeneralResponse {
  success?: boolean;
  message?: string | undefined;
  status?: EResponseStatus;
  resource?: UserPaginatedList;
}

export interface User {
  id?: string | undefined;
  userName?: string | undefined;
  normalizedUserName?: string | undefined;
  email?: string | undefined;
  normalizedEmail?: string | undefined;
  emailConfirmed?: boolean;
  passwordHash?: string | undefined;
  securityStamp?: string | undefined;
  concurrencyStamp?: string | undefined;
  phoneNumberConfirmed?: boolean;
  twoFactorEnabled?: boolean;
  lockoutEnd?: Date | undefined;
  lockoutEnabled?: boolean;
  accessFailedCount?: number;
  nationalId?: string | undefined;
  phoneNumber?: string | undefined;
  birthDate?: string | undefined;
  isAcceptTerms?: boolean;
  userTypeId?: EUserType;
  userRoleId?: EUserRole;
  investTypeId?: InvestorDegreeType;
  isActivated?: boolean;
  isSuspended?: boolean;
  createdAt?: Date;
  createdBy?: string | undefined;
  updatedAt?: Date | undefined;
  updateBy?: string | undefined;
  deletedAt?: Date | undefined;
  deletedBy?: string | undefined;
  isDeleted?: boolean;
  gender?: Gender;
  isCompleteProfile?: boolean;
  defaultLanguage?: Language;
  profileImageUrl?: string | undefined;
  city?: string | undefined;
  district?: string | undefined;
  buildingNumber?: string | undefined;
  additionalNumber?: string | undefined;
  objLatLng?: string | undefined;
  postCode?: string | undefined;
  isPrimaryAddress?: boolean;
  street?: string | undefined;
  lastName?: string | undefined;
  lastNameAr?: string | undefined;
  englishName?: string | undefined;
  arabicName?: string | undefined;
  fatherNameAr?: string | undefined;
  fatherName?: string | undefined;
  grandFatherName?: string | undefined;
  grandFatherNameAr?: string | undefined;
  idExpirationDate?: string | undefined;
  isVerifiedYakeen?: boolean;
  isVerifiedAbsher?: boolean;
  isVerifiedMozn?: boolean;
  isVerifiedWathiq?: boolean;
  moznStatus?: UserStatus;
  userRoles?: StringIdentityUserRole[] | undefined;
  readonly fullName?: string | undefined;
  readonly fullNameAr?: string | undefined;
}

export enum UserStatus {
  Approved = 'Approved',
  InReview = 'InReview',
  Suspended = 'Suspended',
}

export interface StringIdentityUserRole {
  userId?: string | undefined;
  roleId?: string | undefined;
}

export enum Language {
  Ar_SA = 'ar_SA',
  En_US = 'en_US',
}

export interface InvestorWaitingListDto {
  phoneNumber: string | undefined;
  email: string | undefined;
  id: string;
  date: Date;
}

export interface InvestorWaitingListDtoPaginatedList {
  pageIndex: number;
  totalPages: number;
  totalCount: number;
  readonly hasPreviousPage: boolean;
  readonly hasNextPage: boolean;
  items: InvestorWaitingListDto[] | undefined;
}

export interface InvestorWaitingListDtoPaginatedListGeneralResponse {
  success: boolean;
  message: string | undefined;
  status: EResponseStatus;
  resource: InvestorWaitingListDtoPaginatedList;
}
export interface UserExpiredDateDto {
  userId: string | undefined;
  iqamaImageUrl: string | undefined;
  idExpirationDate: string | undefined;
}

export interface CreateSystemUserDto {
  arabicName: string;
  englishName: string;
  email: string;
  birthDate: string;
  nationalId: string;
  phoneNumber: string;
  password: string;
  userRoleId?: EUserRole;
  confirmPassword: string;
  isActivated: boolean;
}

export interface UpdateSystemUserDto {
  id: string;
  englishName: string;
  arabicName: string;
  email: string;
  nationalId: string;
  phoneNumber: string;
  birthDate: Date;
  isActivated: boolean;
  // Only applied by the API when the user is currently deactivated; omit to leave the role unchanged.
  userRoleId?: EUserRole;
}

export interface UserDtoPaginatedListGeneralResponse {
  success?: boolean;
  message?: string | undefined;
  status?: EResponseStatus;
  resource?: UserDtoPaginatedList;
}

export interface CreateFundManagerDto {
  name: string;
  email: string;
  creationDate: string;
  cRNumber: string;
  phoneNumber: string;
  isActivated: boolean;
  anbVirtualIban: string;
}

export interface UpdateFundManagerDto {
  id: string;
  name: string;
  email: string;
  creationDate: string;
  cRNumber: string;
  phoneNumber: string;
  isActivated: boolean;
  anbVirtualIban: string;
}
export interface FundManagerDto {
  fundId?: string;
  id?: string;
  name?: string;
  email?: string;
  creationDate?: Date;
  phoneNumber?: string;
  crNumber?: string;
  isActive?: boolean;
  establishment?: Date;
  virtualIban?: string;
}
export interface GetFundManagerByEmailOutputDto {
  email: string;
  isCompleteProfile: boolean;
}
export interface FileParameter {
  data: any;
  fileName: string;
}

export enum InvitationLanguage {
  Arabic = 'ar',
  English = 'en',
}

export interface CreateInvitationDto {
  email?: string | undefined;
  nationalId?: string | undefined;
  phoneNumber?: string | undefined;
  birthDate?: string | undefined;
  invitationLanguage?: InvitationLanguage;
}

export interface EditInvitationDto extends CreateInvitationDto {
  id?: string | undefined;
}

// Body for CancelInvitation / ResendInvitation, which only need the row id.
export interface InvitationIdDto {
  id?: string | undefined;
}

// Pending/Accepted/Expired kept distinct from the unrelated InvitationStatus
// (Sent/Failed) enum below, which is only for the bulk-upload sheet response.
export enum InvitationRowStatus {
  Pending = 'Pending',
  Accepted = 'Accepted',
  Expired = 'Expired',
  Cancelled = 'Cancelled',
}

export type InvitationAllowedAction = 'edit' | 'cancel' | 'resend';

export interface InvitedUserDto {
  id?: string;
  email?: string | undefined;
  nationalId?: string | undefined;
  phoneNumber?: string | undefined;
  // Pre-formatted by the API, e.g. "+966 55 123 4567" - use this for display, not phoneNumber.
  phoneNumberDisplay?: string | undefined;
  birthDate?: string | undefined;
  fileNumber?: string | undefined;
  investmentAccount?: string | undefined;
  iban?: string | undefined;
  isCompleteInvitation?: boolean;
  status?: InvitationRowStatus | string | undefined;
  createdAt?: string | undefined;
  invitationLanguage?: InvitationLanguage | string | undefined;
  emailDeliveryFailed?: boolean;
  // Which action buttons the API says are valid for this row right now.
  allowedActions?: InvitationAllowedAction[] | undefined;
}

export interface InvitationCountsDto {
  all?: number;
  pending?: number;
  accepted?: number;
  expired?: number;
  cancelled?: number;
}

export interface InvitationCountsDtoGeneralResponse {
  success?: boolean;
  message?: string | undefined;
  status?: EResponseStatus;
  resource?: InvitationCountsDto;
}

export interface InvitedUserDtoPaginatedList {
  pageIndex?: number;
  totalPages?: number;
  totalCount?: number;
  readonly hasPreviousPage?: boolean;
  readonly hasNextPage?: boolean;
  items?: InvitedUserDto[] | undefined;
}

export interface InvitedUserDtoPaginatedListGeneralResponse {
  success?: boolean;
  message?: string | undefined;
  status?: EResponseStatus;
  resource?: InvitedUserDtoPaginatedList;
}

export interface InvitationSheetResponse {
  nationalId?: string | undefined;
  status?: InvitationStatus;
  reason?: string | undefined;
}

export interface InvitationSheetResponseListGeneralResponse {
  success?: boolean;
  message?: string | undefined;
  status?: EResponseStatus;
  resource?: InvitationSheetResponse[] | undefined;
}
export enum InvitationStatus {
  Sent = 'Sent',
  Failed = 'Failed',
}
export interface VerifyUserOnMoznInputDto {
  date: string;
  language: string;
  fName: string;
  lName: string;
  mName: string;
  nin: string;
}
export interface VerifyUserOnMoznOutputDto {
  moznStatus: string;
  screenResult: string[];
}
export interface GetInvestorMoznStatusHistoryOutputDto {
  id: string;
  oldStatus: string;
  newStatus: string;
  moznResponse: string;
  createdAt: Date;
  actorName: string;
}
export interface SearchInvestorsOutputDto {
  userId: string;
  fullName: string;
}

export interface RiskLogEntryDto {
  id?: string;
  investorId?: string;
  riskLevel?: number;
  createdAt?: string;
  createdBy?: string;
  createdByName?: string;
  isDeletable?: boolean;
}

// Bulk Invitation Models
export interface BulkInvitationRowErrorDto {
  column?: string;
  message?: string;
}

export interface BulkInvitationRowPreviewDto {
  rowNumber: number;
  email?: string;
  nationalId?: string;
  phoneNumber?: string;
  birthDate?: string;
  status: 'Valid' | 'Error' | string;
  errors?: BulkInvitationRowErrorDto[];
}

export interface BulkInvitationValidationResource {
  jobId: string;
  total: number;
  valid: number;
  errors: number;
  confirmMessage?: string;
  rows?: BulkInvitationRowPreviewDto[];
}

export interface BulkInvitationValidationResponse {
  success?: boolean;
  message?: string;
  status?: EResponseStatus;
  resource?: BulkInvitationValidationResource;
}

export interface StartBulkInvitationInputDto {
  jobId: string;
}

export interface BulkInvitationResultRowDto {
  rowNumber: number;
  email?: string;
  nationalId?: string;
  phoneNumber?: string;
  birthDate?: string;
  status: 'Sent' | 'Failed' | 'Skipped' | string;
  reason?: string;
  errors?: BulkInvitationRowErrorDto[];
}

export interface BulkInvitationJobResource {
  jobId: string;
  status: 'Pending' | 'Processing' | 'Completed' | 'Failed' | string;
  processed: number;
  valid: number;
  total: number;
  sent: number;
  failed: number;
  skipped: number;
  confirmMessage?: string;
  rows?: BulkInvitationResultRowDto[];
}

export interface BulkInvitationJobResponse {
  success?: boolean;
  message?: string;
  status?: EResponseStatus;
  resource?: BulkInvitationJobResource;
}
